export const handleSelectQuestion = (dictionary, tree) => {
    return (current_tree = tree) => {
        const answer_tree = current_tree.c
        const item = {}
        item.content = dictionary[current_tree.t]
        item.end = !answer_tree.length
        if (!item.end) {
            item.answers = answer_tree.map((answer, i) => {
                const { t, r, c } = answer
                return {
                    order: ['A', 'B', 'C', 'D'][i],
                    question_index: t,
                    desc: dictionary[r],
                    content: dictionary[t],
                    tree: c && c.length === 1 ? c[0] : {}
                }
            })
        } else {
            item.result = dictionary[current_tree.t]
            item.desc = dictionary[current_tree.r]
        }
        return item
    }
}
